import { SETNOTIFICATIONCOUNT } from "./type";

export const setNotificationCount = (payload: number) => {
  return { type: SETNOTIFICATIONCOUNT, payload };
};
